import { usewpdataSelectors } from 'lib/wpdataState/selectors';
import s from '../CTA/Button.module.scss';
import { CSSProperties } from 'react';

type CTAProps = {
  text: string;
  className: string;
  attribute?: string;
  style?: CSSProperties;
  handleClick?: () => void;
};

const Link = ({ text, className, attribute, style, handleClick }: CTAProps) => {
  const { Theme } = usewpdataSelectors();

  return (
    <a
      data-cy={attribute}
      style={style}
      href={'#product-picker'}
      data-theme={Theme?.button}
      className={`${className} cta ${s.cta}`}
      onClick={handleClick}
    >
      {text}
    </a>
  );
};

export default Link;
